import styled from 'styled-components';
import { device } from './Theme';

export const Container = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
`;

export const Heading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.heading};

  @media ${device.tablet} {
    font-size: 2.2rem;
    margin-bottom: 1.4rem;
  }
  @media ${device.mobile} {
    font-size: 1.8rem;
    margin-bottom: 1.3rem;
  }
`;
